<template>
  <div
    class="present-content"
    :class="[{ '--is-collapsed' : isCollapsed }, { '--is-empty' : ($store.getters.getSelectedItem.data === null || !$store.getters.getSelectedItem.data.products.length) }, '--is-level' + $store.getters.getCurrentLevel]">

    <div class="present-content__backdrop" @click="handlePanel"></div>

    <transition name="present-content-transition">
      <div class="present-content__area" v-show="isVisible">
        <button
          @click="handlePanel()"
          class="present-content__handle"
        >
          <slot v-if="isCollapsed">
            Details anzeigen <i class="icon icon-angle-up"></i>
          </slot>

          <slot v-else>
            Details ausblenden <i class="icon icon-angle-down"></i>
          </slot>
        </button>

        <div class="present-content__panel">
          <header v-if="isCollapsed" class="present-content__header">
            <h4 class="present-content__name">
              <slot v-if="$store.getters.getCurrentLevel === 1 && $store.getters.getSelectedItem.data === null">
                Kein Produkt ausgewählt
              </slot>

              <slot v-else-if="$store.getters.getCurrentLevel === 1">
                {{ $store.getters.getSelectedItem.data.name }}
              </slot>

              <slot v-else>
                Individuelles Präsent
              </slot>
            </h4>

            <p class="present-content__counter">
              <slot v-if="$store.getters.getSelectedItem.data">
                {{ $store.getters.getSelectedItem.data.products.length }} Delikatessen
                <slot v-if="$store.getters.getCurrentLevel === 1">enthalten</slot>
                <slot v-else>ausgewählt</slot>
              </slot>

              <slot v-else>
                Noch keine Delikatessen
              </slot>
            </p>

            <span class="present-content__delivery-time">
              <slot v-if="$store.getters.getFutureDate.use">√ ab {{ $store.getters.getFutureDate.val }}</slot>
              <slot v-else>√ {{ deliveryTimeString }}</slot>
            </span>

            <slot v-if="$store.getters.getSelectedItem.data !== null">
              <!-- alerts -->
              <Alert
                type="info"
                v-if="
                !$store.getters.isMobile &&
                    $store.getters.getCurrentLevel === 3 &&
                      $store.getters.getLevel3Available &&
                        !$store.getters.getLevel3NotAvailable"
                class="present-content__alert"
              >
                Fast voll
              </Alert>

              <Alert
                type="warning"
                v-else-if="
                !$store.getters.isMobile &&
                    $store.getters.getCurrentLevel === 3 &&
                      $store.getters.getLevel3Available &&
                        $store.getters.getLevel3NotAvailable"
                class="present-content__alert"
              >
                Kein Platz
              </Alert>

              <Alert
                  type="warning"
                  v-else-if="$store.getters.getCurrentLevel === 1 && $store.getters.getSelectedItem.maxQty($store) < boxQty && $store.getters.isB2b"
                  class="present-content__alert"
              >
                Leider kann diese Konfiguration nicht mit der gewünschten Menge bestellt werden. Bitte kontaktieren Sie uns für eine individuelle Verfügbarkeitsprüfung.
              </Alert>

              <Alert
                  type="warning"
                  v-else-if="$store.getters.getCurrentLevel === 1 && !selectedIsInList() && $store.getters.isB2b"
                  class="present-content__alert"
              >
                Das ausgewählte Produkt ist nicht in der gewünschten Menge verfügbar.
              </Alert>

              <Alert
                type="warning"
                v-else-if="$store.getters.getCurrentLevel === 1 && $store.getters.getSelectedItem.maxQty($store) < boxQty && !$store.getters.isB2b"
                class="present-content__alert"
              >
                <strong>Menge nicht verfügbar</strong><br>
                <a :href="'/praesente/b2b/fertige/' + $store.getters.getSelectedItem.data.id + '?switch_group=b2b'">Sie sind B2B-Kunde?</a>
              </Alert>

              <Alert
                type="warning"
                v-if="$store.getters.getCurrentLevel === 3 && !allInList() && $store.getters.isB2b"
                class="present-content__alert"
              >
                Die ausgewählten Produkte sind nicht in der gewünschten Menge verfügbar.
              </Alert>

              <Alert
                type="warning"
                v-else-if="$store.getters.getCurrentLevel === 3 && $store.getters.getSelectedItem.maxQty($store) < boxQty && !$store.getters.isB2b"
                class="present-content__alert"
              >
                <strong>Menge nicht verfügbar</strong><br>
                <a :href="'/praesente/b2b/zusammenstellen/?switch_group=b2b'">Sie sind B2B-Kunde?</a>
              </Alert>
            </slot>
            <!-- /alerts -->
          </header>

          <div v-if="!isCollapsed">
            <Composer v-if="!isCollapsed" environment="configurator" ref="composer" />
          </div>

          <ul v-if="isCollapsed" ref="products" class="present-content__products">
            <!-- dynamic products -->
            <li v-for="(product, index) in products" :key="index" class="present-content__product" :class="{ '--is-unavailable' : productIsUnavailable(product) }">
              <div class="present-content__product-link" @click="openModalDetailProduct($store.getters.getCurrentLevel === 1 ? product.product : product.id)">
                <div class="present-content__product-photo-wrapper">
                  <img
                    :src="`${product.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=96&nearlossless=1`" :alt="product.name"
                    class="present-content__product-photo"
                  >

                  <div
                    v-if="productIsUnavailable(product)"
                    class="present-content__product-photo-icon"
                  >
                    <i class="icon icon-warning"></i>
                  </div>
                </div>

                <div class="present-content__product-info">
                  <h6 class="present-content__product-name" v-if="$store.getters.getCurrentLevel === 1">{{ product.quantity }}x {{ product.name }}</h6>
                  <h6 class="present-content__product-name" v-else>{{ product.name }}</h6>

                  <p class="present-content__product-description">
                    {{ productDetailString(product) }}
                  </p>

                  <p
                    v-if="$store.getters.getCurrentLevel === 3"
                    class="present-content__product-price"
                  >
                    <span><b>{{ getPriceLevel3ForGroup(product, $store.getters.getUserGroupId, false) }}</b> inkl. Mwst.</span>
                    <small><b>{{ getPriceLevel3ForGroup(product, $store.getters.getUserGroupId, true) }}</b> zzgl. Mwst.</small>
                  </p>
                </div>

                <ButtonRemove
                  v-if="$store.getters.getCurrentLevel === 3"
                  class="present-content__product-remove"
                  :data-algo="index"
                  @click="removeProduct(index)"
                />
              </div>
            </li>
            <!-- /dynamic products -->

            <!-- static packaging product -->
            <li class="present-content__product --is-packaging">
              <div class="present-content__product-link">
                <div class="present-content__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/box.jpg')}?format=${webPFormat('jpeg')}&width=96&height=96&crop=smart&quality=80&compression=4`"
                    alt="Box"
                    class="present-content__product-photo"
                  >
                </div>

                <div class="present-content__product-info">
                  <h6 class="present-content__product-name">Edle Geschenkverpackung mit Magnetverschluss</h6>

                  <p class="present-content__product-description">
                    inkl. handgeschriebener Grußkarte
                  </p>

                  <p
                    v-if="$store.getters.getCurrentLevel === 3"
                    class="present-content__product-price"
                  >
                    <span><b>{{ getPriceBoxForGroup($store.getters.getUserGroupId, false) }}</b> inkl. Mwst.</span>
                    <small><b>{{ getPriceBoxForGroup($store.getters.getUserGroupId, true) }}</b> zzgl. Mwst.</small>
                  </p>
                </div>
              </div>
            </li>
            <!-- /static packaging product -->

            <!-- offer to customize level 1 present -->
            <li
              v-if="!isCollapsed && $store.getters.getCurrentLevel === 1 && products.length"
              class="present-content__product --is-offer"
            >
              <router-link :to="cLink(`/zusammenstellen?__addLevel3s=${$store.getters.getSelectedItem.includedProducts().map(p => p.product).join(',')}`)" class="present-content__product-link">
                <div class="present-content__product-photo-wrapper">
                  <img
                    src="@/assets/images/icon-lightbulb.svg"
                    class="present-content__product-photo"
                  >
                </div>

                <div class="present-content__product-info">
                  <h6 class="present-content__product-name">Präsentinhalt bearbeiten</h6>

                  <p class="present-content__product-description">
                    Sie bestimmen jede Delikatesse individuell
                  </p>
                </div>
              </router-link>
            </li>
            <!-- /offer to customize level 1 present -->
          </ul>
        </div>
      </div>
    </transition>

    <footer v-if="isCollapsed" class="present-content__footer">
      <div class="present-content__price">
        <slot v-if="$store.getters.getCurrentLevel === 1">
          <span>
            <b>{{ getPriceForLevel1($store.getters.getUserGroupId, false) }}</b> inkl. Mwst. zzgl. Versand
          </span>
          <br>
          <small><b>{{ getPriceForLevel1($store.getters.getUserGroupId, true) }}</b> zzgl. Mwst.</small>
        </slot>

        <slot v-else>
          <span>
            <b>{{ getPriceForLevel3($store.getters.getUserGroupId, false) }}</b> inkl. Mwst. zzgl. Versand
          </span>
          <br>
          <small><b>{{ getPriceForLevel3($store.getters.getUserGroupId, true) }}</b> zzgl. Mwst.</small>
        </slot>
      </div>

      <div class="present-content__cta-combo">
        <div class="present-content__quantity-selector">
          <input type="number" min="1" :max="$store.getters.getSelectedItem.maxQty($store)" inputmode="numeric" pattern="[0-9]*" v-model="boxQty" class="form__control">
        </div>

        <slot v-if="$store.getters.getCurrentLevel === 1">
          <Button
            type="button"
            appearance="primary"
            class="present-content__btn --is-disabled"
            v-if="
              $store.getters.getSelectedItem.data === null ||
                $store.getters.getSelectedItem.maxQty($store) < boxQty ||
                !selectedIsInList()
            "
          >
            Weiter <i class="icon icon-angle-right"></i>
          </Button>
          <Button v-else @click="submit()" appearance="primary" class="present-content__btn">Weiter <i class="icon icon-angle-right"></i></Button>
        </slot>
        <slot v-else>
          <Button
            type="button"
            appearance="primary"
            class="present-content__btn --is-disabled"
            v-if="
              $store.getters.getSelectedItem.data === null ||
                $store.getters.getSelectedItem.data.products.length < 1 ||
                !allInList()
            "
          >
            Weiter <i class="icon icon-angle-right"></i>
          </Button>
          <Button v-else @click="submit()" appearance="primary" class="present-content__btn">Weiter <i class="icon icon-angle-right"></i></Button>
        </slot>
      </div>
    </footer>
  </div>
</template>

<script>
// import debounce from 'lodash.debounce';
import Headroom from 'headroom.js';

import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';

import Alert from '@/components/Alert';
import Button from '@/components/Common/Button';
import ButtonRemove from '@/components/ButtonRemove';
import Composer from '@/components/Composer/Composer';

export default {
  name: 'PresentContent',
  components: {
    Alert,
    Button,
    ButtonRemove,
    Composer
  },
  mixins: [logicMixin, helperMixin],
  data () {
    return {
      isCollapsed: true,
      isVisible: false,
      elements: {
        body: document.body
      },
      deliveryTimeString: '',
      products: []
    };
  },
  created() {
    this.elements.body.style.setProperty('overflow', 'visible');

    this.$root.$on('level1Loaded', () => {
      if (this.$store.getters.getSelectedItem && this.$store.getters.getSelectedItem.data) {
        if (this.$store.getters.getSelectedItem.data.type === 'level_1') {
          this.products = this.$store.getters.getSelectedItem.data.products.filter(p => p.type !== 'box');
          this.deliveryTimeString = this.getDeliveryTimeString();
        } else {
          this.products = [];
        }
      }

      this.isVisible = true;
    });

    this.$root.$on('level1Selected', () => {
      if (this.$store.getters.getSelectedItem && this.$store.getters.getSelectedItem.data) {
        this.products = this.$store.getters.getSelectedItem.data.products.filter(p => p.type !== 'box');
        this.deliveryTimeString = this.getDeliveryTimeString();

        this.isVisible = true;
      }
    });

    this.$root.$on('level3Selected', () => {
      this.products = [...this.$store.getters.getSelectedItem.includedProducts()];
      this.deliveryTimeString = this.getDeliveryTimeString();

      this.isVisible = true;
    });

    this.$root.$on('addedLevel3Item', () => {
      this.addProduct(() => {
        this.products = [...this.$store.getters.getSelectedItem.includedProducts()];
        this.deliveryTimeString = this.getDeliveryTimeString();
      });
    });

    this.$root.$on('removedLevel3Item', () => {
      this.deliveryTimeString = this.getDeliveryTimeString();
      this.products = [...this.$store.getters.getSelectedItem.includedProducts()];
    });

    if (this.$store.getters.getSelectedItem.data) {
      if (this.$store.getters.getCurrentLevel === 1) {
        this.products = this.$store.getters.getSelectedItem.data.products.filter(p => p.type !== 'box');
      } else {
        this.products = this.$store.getters.getSelectedItem.includedProducts();
      }
      this.deliveryTimeString = this.getDeliveryTimeString();
    }
  },
  methods: {
    handlePanel () {
      this.isCollapsed ? this.isCollapsed = false : this.isCollapsed = true;
    },

    addProduct (callback) {
      const timeout = this.isVisible ? 0 : 400;

      if (!this.isVisible) {
        this.headroom.pin();
      }

      setTimeout(() => {
        callback();
      }, timeout);
    },

    getDeliveryTimeString () {
      // if ([62, 2569, 2571, 2548].includes(parseInt(this.$store.getters.getUserGroupId))) return 'Spätestens KW 51';
      const days = this.$store.getters.getSelectedItem.getDeliveryTime(this.$store);
      if (days === 0 || days === 1) return 'sofort versandfertig';
      if (days > 1 && days <= 14) return `in ${days} Tagen versandfertig`;
      return `am ${this.getDeliveryReadyDateString(days)} versandfertig`;
    },

    allInList () {
      var allInList = true;
      if (this.$store.getters.getSelectedItem.data !== null) {
        this.$store.getters.getSelectedItem.data.products.forEach(element => {
          var eInList = false;
          this.$store.getters.getListItemsLevel3.forEach(element2 => {
            if (element.id === element2.id) {
              eInList = true;
            }
          });

          if (!eInList) {
            allInList = false;
          }
        });
      }

      return allInList;
    },

    submit () {
      this.isVisible = true;
      this.isCollapsed = false;

      setTimeout(() => {
        this.$refs.composer.submit();
      }, 20);
    },

    openModalDetailProduct (productId) {
      if (
        this.$store.getters.getSelectedItem.data !== null &&
        this.$store.getters.getSelectedItem.data.type === 'level_1'
      ) {
        this.$router.push(this.cLink('/fertige/' +
            this.$store.getters.getSelectedItem.data.id +
            '/Details/' +
            productId));
      } else if (
        this.$store.getters.getSelectedItem.data !== null &&
        this.$store.getters.getSelectedItem.data.type === 'level_3'
      ) {
        this.$router.push(this.cLink('/zusammenstellen/' +
            productId +
            '/Details'));
      }
    },

    getPriceForLevel1(group, tax) {
      if (this.$store.getters.getSelectedItem && this.$store.getters.getSelectedItem.data) {
        return this.getPriceForGroup(this.$store.getters.getSelectedItem.data, group, tax);
      }

      return '0,00 €';
    },

    getPriceForLevel3(group, tax) {
      if (this.$store.getters.getSelectedItem && this.$store.getters.getSelectedItem.data) {
        return this.humanPrice(
          (this.$store.getters.getSelectedItem.rawPrice(
            group,
            tax,
            tax
          ) +
                    this.getPriceBoxRawForGroup(group, tax))
        );
      }

      return this.humanPrice(this.getPriceBoxRawForGroup(group, tax));
    }
  },

  watch: {
    isCollapsed () {
      if (this.isCollapsed) {
        this.elements.body.style.setProperty('overflow', 'visible');
        this.headroom.unfreeze();
      } else {
        this.elements.body.style.setProperty('overflow', 'hidden');
        this.headroom.freeze();
      }
    },

    isVisible () {
      if (this.headroom) {
        if (this.isVisible) {
          this.headroom.pin();
        } else {
          this.headroom.unpin();
        }
      }
    }
  },

  mounted () {
    this.headroom = new Headroom(this.$el, {
      tolerance: 3,
      onPin: () => {
        this.isVisible = true;
      },
      onUnpin: () => {
        this.isVisible = false;
      }
    });

    this.headroom.init();

    if (window.location.hash && window.location.hash === '#edit') {
      this.isVisible = true;
      this.isCollapsed = false;
    }
  },

  beforeDestroy () {
    this.headroom.destroy();
  }
};
</script>

<style lang="scss" scoped>
/**
 * PresentContent
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc New present's content for mobile
 * @since 2021-05-13
**/

$component: 'present-content';

.#{$component} {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  width: 100%;
  height: auto;
  max-height: auto;

  &__backdrop {
    content: '';
    display: block;
    background: $ink;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    opacity: 0.8;
    transition: all 0.1s ease-in-out;
  }

  &__area {
    will-change: transform;
    position: relative;
    z-index: -1;
  }

  &__handle {
    display: block;
    margin-left: auto;
    margin-right: auto;
    @include padding(map-get($spacers, 1) map-get($spacers, 3));
    border: none;
    border-top-left-radius: $border-radius-lg;
    border-top-right-radius: $border-radius-lg;
    outline: none;
    background: $white;
    box-shadow: 0px -6px 21px rgba(33, 43, 54, 0.07), 0px 1px 3px rgba(33, 43, 54, 0.15), 0px 0px 0px 1px rgba(33, 43, 54, 0.05);
    color: $ink-lighter;

    .icon {
      zoom: 1.6;
      vertical-align: middle;
      @include margin-right(- map-get($spacers, 1));
      line-height: 0;
    }

    &:active {
      background: $sky;
    }
  }

  &__panel {
    border-top-left-radius: $border-radius-lg;
    border-top-right-radius: $border-radius-lg;
    box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05),
                0 1px 3px 0 rgba(63, 63, 68, 0.15);
    background-color: $white;
  }

  // Header
  &__header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    @include padding(map-get($spacers, 2) map-get($spacers, 3));
  }

  &__name {
    flex-basis: 100%;
    margin: 0;
    @include font-size($font-size-lg * 1.3);
  }

  &__counter {
    width: 50%;
    margin: 0;
    color: $ink-lighter;
  }

  &__delivery-time {
    min-width: 40%;
    color: $green;
    font-weight: $font-weight-bold;
    text-align: right;
  }

  &__alert {
    flex-basis: 100%;
    margin: 0;
    @include margin-top(map-get($spacers, 2));
    @include margin-bottom(map-get($spacers, 1));
    @include padding-top(map-get($spacers, 2));
    @include padding-bottom(map-get($spacers, 2));
  }

  // Products list
  &__products {
    @include unlist;
    position: relative;
    overflow: hidden;
    height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;
    // @include padding(0 map-get($spacers, 3));
    // border-bottom: 1px solid $gray-ghost;
    transition: all 0.2s ease-in-out;
  }

  &__product {
    @include margin-right(map-get($spacers, 3));
    @include margin-left(map-get($spacers, 3));
    @include margin-bottom(map-get($spacers, 3));

    &.--is-unavailable {
      .#{$component} {
        &__product-photo {
          opacity: 0.5;
        }
      }
    }
  }

  &__product-link {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    color: $ink;

    &:hover {
      text-decoration: none;
    }
  }

  &__product-photo-wrapper {
    flex-basis: 48px;
    flex-shrink: 0;
    position: relative;
    padding: 3px;
    border: 1px solid $gray-ghost;
    border-radius: $border-radius;
    cursor: pointer;
  }

  &__product-photo {
    display: block;
    width: 40px;
    height: 40px;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: $border-radius;
  }

  &__product-photo-icon {
    position: absolute;
    top: 30%;
    left: 0;
    right: 0;
    margin: 0 auto;
    line-height: 1;
    text-align: center;

    .icon {
      padding: 2px;
      border-radius: 50%;
      // background-color: lighten($yellow, 19);
      text-shadow: 0 0 5px $yellow;
      color: darken($yellow, 50);
      @include font-size($font-size-lg * 1.4);
      line-height: 1;
    }
  }

  &__product-info {
    width: 100%;
    @include margin-left(map-get($spacers, 3));
  }

  &__product-name {
    display: block;
    margin: 0;
    @include font-size($font-size-base);
    font-family: $font-family-sans-serif;
    font-weight: $font-weight-bold;
    cursor: pointer;
  }

  &__product-description {
    width: 100%;
    overflow: hidden;
    margin: 0;
    color: $ink-lighter;
    @include font-size($font-size-sm);
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__product-price {
    margin: 0;
    @include margin-top(map-get($spacers, 1));
    @include font-size($font-size-sm);

    > small {
      color: $ink-lightest;
      letter-spacing: -0.5px;

      &:before {
        content: ' | ';
      }
    }
  }

  &__product-remove {
    flex: 0 0 16px;
    zoom: 1.2;
  }

  // Footer
  &__footer {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    @include padding(map-get($spacers, 2) map-get($spacers, 3));
    @include padding-bottom(map-get($spacers, 5));
    border-top: 1px solid $gray-ghost;
    background-color: $white;
  }

  &__price {
    flex: 1 0 50%;
    @include font-size($font-size-sm);

    span b {
      @include font-size($font-size-lg);
    }

    small,
    small b {
      color: $ink-lightest;
      @include font-size($font-size-sm);
    }

    a {
      color: $ink-lightest;
      text-decoration: underline;
    }
  }

  &__cta-combo {
    display: flex;
  }

  &__quantity-selector {
    @include margin-right(map-get($spacers, 2));
    input[type='number'] {
      width: 50px;
    }
  }

  &__btn {
    flex-grow: 1;

    .icon {
      zoom: 1.8;
      vertical-align: middle;
      @include font-size($font-size-xl);
      line-height: 0;
      @include margin-right(- map-get($spacers, 1));
      @include margin-left(- map-get($spacers, 1));
    }
  }

  // Collapsed state
  &.--is-collapsed {
    z-index: 10;

    .#{$component} {
      &__backdrop {
        opacity: 0;
        pointer-events: none;
      }

      &__header {
        padding-bottom: 0;
      }

      &__products {
        display: flex;
        height: auto;
        flex-wrap: nowrap;
        // justify-content: start;
        overflow-x: scroll;
        overflow-y: visible;
        padding-right: 0;
        padding-left: 0;
        @include padding-top(map-get($spacers, 2));
        @include padding-bottom(map-get($spacers, 2));

        scrollbar-width: 0;
        scrollbar-height: 0;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      &__product {
        flex: 0 0 48px;
        margin: 0;
        @include margin-right(map-get($spacers, 3));
        opacity: 1;
        transition: opacity 0.2s ease-in-out;

        &:first-child {
          @include margin-left(map-get($spacers, 3));
        }
      }

      &__product-link {
        display: flex;
        position: relative;
      }

      &__product-photo-wrapper {
        width: 100%;
      }

      &__product-photo {
        // width: 100%;
        // height: auto;
      }

      &__product-info {
        display: none;
      }

      &__product-remove {
        position: absolute;
        top: -6px;
        right: -6px;
        zoom: 1.2;
      }
    }
  }

  // Empty state
  &.--is-empty {
    .#{$component} {
      &__delivery-time {
        display: none;
      }
    }

    &.--is-collapsed .#{$component}__product.--is-packaging {
      flex-basis: calc(100% - 30px);

      .#{$component} {
        &__product-info {
          display: block;
        }

        &__product-price {
          display: none;
        }
      }
    }
  }

  // Product item exceptions
  &__product.--is-offer {
    @include padding-top(map-get($spacers, 3));
    border-top: 1px solid $gray-ghost;

    .#{$component} {
      &__product-name {
        color: $blue;
      }

      &__product-description {
        overflow: unset;
        text-overflow: unset;
        white-space: unset;
      }
    }
  }

  // Level 1 exceptions
  &.--is-level1 {
    .#{$component} {
      &__product-info {
        width: calc(100% - 60px);
      }
    }
  }

  // Level 3 exceptions
  &.--is-level3 {
    .#{$component} {
      &__product-info {
        width: calc(100% - 80px);
      }

      &__product.--is-packaging .#{$component}__product-info {
        width: calc(100% - 60px);
      }
    }
  }
}

@keyframes area-in {
  0% {
    transform: translate3d(0, 100%, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes area-out {
  0% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(0, 100%, 0);
  }
}

/* Present Sticky Transition */
.present-content-transition-enter-active, .present-content-transition-leave-active {
  transition: transform 0.4s;
}
.present-content-transition-enter, .present-content-transition-leave-to {
  transform: translate3d(0, 100%, 0);
}
</style>
